import script from "./BarView.vue?vue&type=script&setup=true&lang=js"
export * from "./BarView.vue?vue&type=script&setup=true&lang=js"

import "./BarView.vue?vue&type=style&index=0&id=76e024e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e024e2"]])

export default __exports__